import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export default function CTABanner() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-20 bg-[#f8faff]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`relative bg-hero-gradient rounded-3xl p-10 sm:p-14 text-center overflow-hidden transition-all duration-700 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
        >
          {/* Background decoration */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute -top-16 -right-16 w-64 h-64 bg-white/5 rounded-full" />
            <div className="absolute -bottom-16 -left-16 w-64 h-64 bg-accent/10 rounded-full" />
          </div>

          <div className="relative">
                          <p className="text-accent text-sm font-semibold tracking-widest uppercase mb-4">
                            Get In Touch
                          </p>
            <h2 className="font-display text-4xl sm:text-5xl font-bold text-white mb-4">
              Celebrating Wellness Together
            </h2>
            <p className="text-blue-200 text-lg max-w-xl mx-auto mb-8">
              Interested in our products or want to partner with us? Reach out to our team and let's build a healthier future.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-white text-primary font-bold px-8 py-4 rounded-full hover:bg-blue-50 transition-all duration-300 hover:-translate-y-0.5 shadow-hero active:scale-95"
              >
                Contact Us Today
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </Link>
              <Link
                to="/products"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white font-bold px-8 py-4 rounded-full hover:bg-white/10 transition-all duration-300 active:scale-95"
              >
                Browse Products
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
